
// 依赖
export default {
  data() {
    return {
    
    }
  },
 
  methods: {
        // 可选：文件删除后的额外操作
    handleFileRemove(removedFile,data,dataItem) {
      console.log("删除的文件：", removedFile);
      console.log("删除的文件列表：", this[data][dataItem]);
      this[data][dataItem].forEach((element,index) => {
        if(element.id == removedFile.id){
            this[data][dataItem].splice(index,1)
        }
      });
      // 如：调用后端删除接口、更新表单等
    },
  }
}


